var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-card"},[_c('h2',[_vm._v(_vm._s(_vm.titleAr))]),_c('p',[_vm._v(_vm._s(_vm.descriptionAr))])])
}
var staticRenderFns = []

export { render, staticRenderFns }